import React from 'react';

export const FreePromoBanners = React.memo(({ freePromoBanners }) => {
	if (!freePromoBanners?.length) return null;
	return (
		<>
			{freePromoBanners.map(promo => (
				<div key={promo.promoCode} className="copies-msg p-2 mt-1">
					<strong>{promo.promoMsg}</strong>
				</div>
			))}
		</>
	);
});